import { render, staticRenderFns } from "./customComponent.vue?vue&type=template&id=3119d1e8&"
import script from "./customComponent.vue?vue&type=script&lang=js&"
export * from "./customComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3119d1e8')) {
      api.createRecord('3119d1e8', component.options)
    } else {
      api.reload('3119d1e8', component.options)
    }
    module.hot.accept("./customComponent.vue?vue&type=template&id=3119d1e8&", function () {
      api.rerender('3119d1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ui-document/components/customComponent.vue"
export default component.exports